import axios from "axios";
import Swal from "sweetalert2";
const baseUrl = `${window.location.origin}/api/`;
const baseimgUrl = `${window.location.origin}/`;
const wsBaseUrl = window.location.protocol === "https:" ? `wss://${window.location.host}` : "ws://127.0.0.1:8000";
// ============================================================
// TELEMEDICINE AXIOS INSTANCE
// Supports BOTH:
// 1. Patient JWT
// 2. Main application JWT
// ============================================================
const telemedicineAxios = axios.create();
telemedicineAxios.interceptors.request.use((config) => {
    const telemedicineRole = localStorage.getItem("telemedicine_role");
    // =====================================================
    // PATIENT
    // =====================================================
    if (telemedicineRole === "patient") {
        const tokens = localStorage.getItem("patAuthTokens");
        if (tokens) {
            try {
                const parsed = JSON.parse(tokens);
                if (parsed?.access) {
                    config.headers.Authorization = `Bearer ${parsed.access}`;
                }
            } catch (error) {
                console.error("Invalid patient token:", error);
            }
        }
    }

        // =====================================================
        // DOCTOR / MAIN APPLICATION
    // =====================================================
    else {
        const tokens = localStorage.getItem("authTokens");
        if (tokens) {
            try {
                const parsed = JSON.parse(tokens);
                if (parsed?.access) {
                    config.headers.Authorization = `Bearer ${parsed.access}`;
                }
            } catch (error) {
                console.error("Invalid main application token:", error);
            }
        }
    }
    // =====================================================
    // HOSPITAL
    // =====================================================
    const hospitalCode = localStorage.getItem("hospital_code");
    if (hospitalCode) {
        config.headers["X-Hospital-Code"] = hospitalCode;
    }
    // =====================================================
    // LOCATION
    // =====================================================
    const location = localStorage.getItem("userLocation");
    if (location) {
        if (!config.params) {
            config.params = {};
        }
        config.params.location = location;
    }
    return config;
}, (error) => Promise.reject(error));
// ============================================================
// RESPONSE
// ============================================================
telemedicineAxios.interceptors.response.use(response => response, error => {
    if (error.response) {
        const status = error.response.status;
        let message = "An error occurred.";
        if (status === 401) {
            message = "Telemedicine authentication failed.";
        } else if (status === 403) {
            message = "You do not have permission to access this telemedicine session.";
        } else if (status === 404) {
            message = "Telemedicine data not found.";
        } else if (status === 500) {
            message = "Internal server error.";
        } else {
            message = error.response.data?.message || error.response.data?.detail || message;
        }
        Swal.fire({
            icon: "error", title: `Error ${status}`, text: message, confirmButtonText: "OK"
        });
    }
    return Promise.reject(error);
});
export {
    baseUrl, baseimgUrl, wsBaseUrl
};
export default telemedicineAxios;